<h1 mat-dialog-title>{{data.status}}</h1>
<div mat-dialog-content>{{data.message}}</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
</div>
